/***********************************
  RequestQuoteForm Module
************************************/

  Quad.RequestQuoteForm = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  var $quoteRequestBtn,
      $formSelector,
      $formSection;


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    $quoteRequestBtn = $( '#quote-request-btn' );
    $formSelector = $( '#form-type-selector' );
    $formSection = $( '#form-section' );

    _addEvents();

  }

  function _addEvents() {
    $quoteRequestBtn.on( 'click', function( event ) {
      event.preventDefault();
      _selectFormType( 'quote' );
      $( '#fieldset' ).addClass( 'quote' );
    });
  }

  function _selectFormType( option ) {
    $formSelector
      .val( option )
      .change();
  }


  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();
